import React from 'react';
import * as _ from 'lodash';
import FieldTreeService from '../services/FieldTrees';
import _dialogLoader from '../utilities/dialogLoader';
import { CommentDetail } from './modals/LaborSafetyDialog';
import {
  FieldTreeFormStore,
  ShowDeleteDialog,
} from '../utilities/LaborSafetyNotify';

/**
 * @description 労安帳票画面で共有して使うコンポーネント
 */

export class PageTitle extends React.Component {
  constructor(props) {
    super(props);

    this.state = { page_title: props.title };

    FieldTreeFormStore.setNotify(v => {
      const name = v[`company_name_${v.nest_no}`] || v.company_name;
      this.setState({
        page_title: props.title.replace(/\{.*\}/, name),
      });
    });
  }

  render() {
    return <h1>{this.state.page_title}</h1>;
  }
}
/**
 * @description 会社の状態を表示するComponent
 */
export class CompanyStatus extends React.Component {
  constructor(props) {
    super(props);

    let ids = window.location.href.match(/([0-9]+,[0-9]+)/);

    if (ids) {
      ids = ids[1].split(',');
      this.field_id = +ids[0];
      this.field_tree_id = +ids[1];
    }

    this.state = {
      comments: [],
      field_tree: {},
      companies_status: [],
    };

    this.deleteFunc = FieldTreeFormStore.setNotify(this.setFieldTree);
  }

  async componentDidMount() {
    if (this.field_id && this.field_tree_id) {
      const data = await FieldTreeService.formStatus(
        this.field_id,
        this.field_tree_id,
        { form_code: 4 }
      );

      if (data && data.result) {
        FieldTreeFormStore.setStore(data.data.entities.field_tree_form_status);
      }
    }
  }

  componentWillUnmount() {
    this.deleteFunc();
  }

  setFieldTree = field_tree => {
    const comments = field_tree.field_tree_form_status_comments || [];
    let status = [];
    let len = 5; //stateの数は 0 ~ 4 (5つ) で固定

    while (len--) {
      if (field_tree[`company_name_${len}`] || len === 0) {
        status.unshift({
          status: +field_tree[`approval_flag_${len}`],
          name: field_tree[`company_name_${len}`],
          level: `${len}次協力会社`,
        });
      }
    }

    this.setState({
      comments,
      field_tree,
      companies_status: status,
    });
  };

  renderStatus() {
    const list = this.state.companies_status;

    return _.map(list, (state, i) => {
      if (i === 0) {
        return (
          <React.Fragment key='company-status-ele-no.0'>
            <CompanyBaseStatus {...state} />
            {i + 1 < list.length ? (
              <i className='i-triangle-left i-3x' />
            ) : null}
          </React.Fragment>
        );
      }

      return (
        <React.Fragment key={`company-status-ele-no.${i}`}>
          <CompanyStatusElement {...state} />
          {i + 1 < list.length ? <i className='i-triangle-left i-3x' /> : null}
        </React.Fragment>
      );
    });
  }

  render() {
    let updated_at = (this.state.field_tree.updated_at || '').match(
      /[0-9]{4}\/[0-9]{1,2}\/[0-9]{1,2}/
    );

    updated_at = updated_at ? updated_at[0] : '---';

    return (
      <div
        id='accordion-main-body__cmp'
        className='accordion labor-safety-constsys-ledger-notify-accordion'
      >
        <div className='labor-safety-form__body'>
          <div className='labor-safety-form__body--header'>
            <div className='labor-safety-form__body--header-item'>
              ステータス
            </div>
            <div className='labor-safety-form__btn'>
              <button className='btn-text--sm labor-safety-form__btn-txt--sm'>
                帳票を更新
              </button>
            </div>
            <div className='labor-safety-form__body--header-item'>
              <div className='labor-safety-form__body--header-date'>
                {`最終更新日：${updated_at}`}
              </div>
            </div>
          </div>

          <div className='labor-safety-form__body--body'>
            {this.renderStatus()}
          </div>
        </div>

        <HeaderComments
          field_id={this.field_id}
          field_tree_id={this.field_tree_id}
          comments={this.state.comments}
          onUpdateComments={this.onUpdateComments}
        />
      </div>
    );
  }
}

/**
 * @description ヘッダーのコメント部分のコンポーネント
 */
const HeaderComments = ({ field_id, field_tree_id, comments }) => {
  if (!_.isObject(comments) || !comments.length) {
    return null;
  }

  let comment = comments.comment || '';
  let user_name = comments.comment_user_name || '---';
  let updated_at = (comments.updated_at || '').match(
    /[0-9]{4}\/[0-9]{1,2}\/[0-9]{1,2}/
  );

  updated_at = updated_at ? updated_at[0] : '---';

  return (
    <div className='labor-safety-constsys-ledger-notify__comment'>
      <p className='labor-safety-constsys-ledger-notify__comment-header'>
        コメント
        <i className='i-file-trash--red i-3x' />
        <a
          className='text--negative'
          onClick={e => {
            e.preventDefault();
            ShowDeleteDialog(
              field_id,
              field_tree_id,
              comments.id,
              FieldTreeFormStore.setStore
            );
          }}
        >
          消去
        </a>
      </p>

      <p className='labor-safety-constsys-ledger-notify__comment-meta'>
        {`ユーザー名：${user_name}`}&emsp;&emsp;{`コメント日時：${updated_at}`}
      </p>

      <p className='labor-safety-constsys-ledger-notify__comment-body'>
        {comment}
        {comment.length < 20 ? '' : '...'}
        <a
          className='text--positive'
          onClick={e => {
            e.preventDefault();
            _dialogLoader.show(CommentDetail, {
              state: { comment, user_name, updated_at },
              callbacks: {
                DeleteDialogShow: () => {
                  ShowDeleteDialog(
                    field_id,
                    field_tree_id,
                    comments.id,
                    FieldTreeFormStore.setStore
                  );
                },
              },
            });
          }}
        >
          全文表示
        </a>
      </p>
    </div>
  );
};

/**
 * @description 会社Status Component
 * @param { { name:String, level:String, status:Number } } props
 */
const CompanyStatusElement = ({ name, level, status }) => (
  <div className='labor-safety-form__body--subconst'>
    <div className='labor-safety-form__body--subconst--company'>
      <div className='labor-safety-form__body--subconst--level'>{level}</div>
      <div className='labor-safety-form__body--subconst--name'>{name}</div>
    </div>
    <div className='labor-safety-form__body--subconst--btn'>
      {getStatusButton(status)}
    </div>
  </div>
);

/**
 * 元請会社専用のStatus Component
 * @param { { status:Number } } props
 */
const CompanyBaseStatus = ({ status }) => (
  <div className='labor-safety-form__body--body-const'>
    <div className='labor-safety-form__body--body-label'>元請</div>
    {getStatusButton(status)}
  </div>
);

export const AccordionToggle = () => (
  <li className='btn-menu__item'>
    <button
      id='accordion-toggle'
      className='accordion__btn'
      onClick={e => {
        const body = document.getElementById('accordion-main-body__cmp');

        if (body.classList.contains('show')) {
          e.target.classList.remove('show');
          body.classList.remove('show');
        } else {
          e.target.classList.add('show');
          body.classList.add('show');
        }
      }}
    />
  </li>
);

/**
 * @description
 * @param {Number} status
 */
const getStatusButton = status => {
  switch (status) {
    case 0:
      return <Unapproved />;
    case 1:
      return <Approved />;
    case 2:
      return <Canseled />;
    case 3:
      return <Submitted />;
    default:
      return <UnSubmitted />;
  }
};

const Unapproved = () => (
  <button className='status-ticket--caution--large conf-status-ticket'>
    未承認
  </button>
);

const UnSubmitted = () => (
  <button className='status-ticket--caution--large conf-status-ticket'>
    未提出
  </button>
);

const Submitted = () => (
  <button className='status-ticket--caution--large conf-status-ticket'>
    提出済み
  </button>
);

const Approved = () => (
  <button className='status-ticket--large conf-status-ticket'>承認済</button>
);

const Canseled = () => (
  <button className='status-ticket--caution--large conf-status-ticket'>
    否認
  </button>
);



// WEBPACK FOOTER //
// ./src/components/LaborSafetyComponents.jsx